import * as React from "react";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { Link, Navigate } from "react-router";

export const SessionExpiredView: React.FC = () => {
  const user = useAuthenticatedUser();

  if (user.isAuthenticated) {
    return <Navigate replace to="/" />;
  }

  return (
    <div className="mb-4 space-y-6 text-center text-lg font-medium text-ui-paragraph-text">
      <p>For security purposes, we automatically log you out after a period of inactivity.</p>
      <p>
        Please{" "}
        <Link className="font-medium text-primary hover:text-primary/80" to="/login">
          sign in
        </Link>{" "}
        to continue.
      </p>
    </div>
  );
};
